import { useEffect } from "react";
export const ResetPasswordPage = RecoveryRedirect;
export default function RecoveryRedirect() {
  useEffect(() => { window.location.replace("/api/auth/recovery"); }, []);
  return <p><a href="/api/auth/recovery">Continue to secure password recovery</a></p>;
}
